import { FaDiscord, FaEthereum, FaGithub, FaLinkedin } from "react-icons/fa";
import { FaBookBookmark, FaXTwitter } from "react-icons/fa6";
import { contractUrl, docsUrl, frontendUrl } from "../../utils/Constants";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex flex-col items-center space-y-4 lg:flex-row lg:items-center lg:space-y-0 pt-[48px] ~px-12/16 ~pb-8/12 w-full">
      {/* Brand Name */}
      <div
        onClick={() => navigate("/", {})}
        className="select-none flex flex-col items-center lg:w-1/3 lg:text-left cursor-pointer text-center ~text-xl/2xl font-bold text-silver font-barlowc z-10 hover:scale-105 duration-250 lg:mb-1 mb-2"
      >
        BITMILLIONS
      </div>

      {/* Social Media Links */}
      <div className="md:w-1/3 flex justify-center flex-col md:flex-row md:space-y-0 space-y-5 z-10">
        {/* First Row (Social Media) */}
        <div className="self-center flex items-center flex-col sm:flex-row space-x-0 sm:space-x-12 space-y-6 sm:space-y-0">
          <div className="flex flex-row items-center space-x-6">
            {/* <div className="relative hover:bg-white mr-[2px] left-[2px] rounded-full h-[16px] w-[16px] hover:scale-110 duration-250">
                            <a
                                href="https://facebook.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="absolute left-[-2px] top-[-2px] hover:text-facebook text-silver"
                            >
                                <FaFacebook size={20} />
                            </a>
                        </div> */}
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-silver hover:text-white hover:scale-110 duration-250"
            >
              <FaXTwitter size={20} />
            </a>
            {/* <div className="hover:bg-gradient-to-br hover:from-instagram1 hover:via-instagram2 hover:to-instagram3 rounded-[6px] hover:scale-110 duration-250">
                            <a
                                href="https://instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-silver hover:text-white"
                            >
                                <FaInstagram size={20} />
                            </a>
                        </div> */}
            <div className="relative hover:bg-white left-[2px] rounded-sm h-[16px] w-[16px] hover:scale-110 duration-250">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute left-[-2px] top-[-2px] hover:text-ethereum text-silver"
              >
                <FaLinkedin size={19} />
              </a>
            </div>
            <div className="hover:bg-discord bg-transparent rounded-full p-[1px] hover:scale-110 duration-250">
              <a
                href="https://discord.com"
                target="_blank"
                rel="noopener noreferrer"
                className=" hover:text-white text-silver text-center"
              >
                <FaDiscord size={19} />
              </a>
            </div>
            {/* <div className="self-center relative hover:bg-white rounded-full h-[18px] w-[18px] hover:scale-110 duration-250">
                            <a
                                href="https://telegram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="absolute hover:text-telegram left-[-1px] top-[-1px] text-silver"
                            >
                                <FaTelegram size={20} />
                            </a>
                        </div> */}
          </div>
          <div className="flex flex-row items-center space-x-6">
            <div className="hover:bg-blue-600 bg-transparent rounded-full hover:scale-110 duration-250">
              <a
                href={contractUrl}
                target="_blank"
                rel="noopener noreferrer"
                className=" hover:text-white text-silver text-center"
              >
                <FaEthereum size={20} />
              </a>
            </div>
            <div className="bg-transparent rounded-full hover:scale-110 duration-250">
              <a
                href={docsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className=" hover:text-white text-silver text-center"
              >
                <FaBookBookmark size={20} className="p-[1px]" />
              </a>
            </div>
            <div className="hover:bg-black bg-transparent rounded-full hover:scale-110 duration-250">
              <a
                href={frontendUrl}
                target="_blank"
                rel="noopener noreferrer"
                className=" hover:text-white text-silver text-center"
              >
                <FaGithub size={20} />
              </a>
            </div>
          </div>
          {/* <a target="_blank" href={"/paper"} className="flex flex-row items-center hover:text-white text-silver space-x-2 hover:scale-105 duration-250 origin-bottom">
                        <FaFileAlt size={20} className="text-center" />
                        <span className="text-sm font-archb">
                            WHITE PAPER
                        </span>
                    </a> */}
        </div>
      </div>
      {/* Copyright Info */}
      <div className="md:w-1/3 flex flex-col">
        <div className="text-center md:text-center text-sm text-silver font-poppins z-10">
          &copy; {new Date().getFullYear()} BitMillions. All rights reserved.
        </div>
      </div>
    </div>
  );
}
